// extracted by mini-css-extract-plugin
export var container = "_lv-0";
export var dotAnimation = "_lv-2";
export var dotsLoading = "_lv-1";